import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useConfirmDialogStore } from "@mirage/store/store";
import "./ConfirmActionDialog.css";

const ConfirmActionDialog = () => {
    const state = useConfirmDialogStore((s) => s.confirmDialog);
    function getTitle(header?: string | JSX.Element) {
        if (typeof header === "string") {
            return <DialogTitle className="confirmActionDialog__title">{header}</DialogTitle>;
        }
        if (typeof header === "object") {
            return header;
        }
        return null;
    }
    const title = getTitle(state.header);

    if (!state.open) {
        return null;
    }
    return (
        <Dialog maxWidth="lg" fullWidth={state.fullWidth} open={state.open} className="confirmActionDialog" PaperProps={{ sx: { overflow: "hidden" } }}>
            {title}
            <DialogContent dividers className="confirmActionDialog__content">
                <Box className="confirmActionDialog__content__mutation">{state.mutation}</Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={state.onReject} variant="outlined">
                    {state.onRejectLabel ? state.onRejectLabel : "No"}
                </Button>
                <Button autoFocus onClick={state.onConfirm} variant="contained" color={state.onConfirmColor || "primary"} disabled={state.onConfirmDisabled}>
                    {state.onConfirmLabel ? state.onConfirmLabel : "Yes"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmActionDialog;
